export default __webpack_public_path__ + "static/Recovery_Bar-d61ecc2922adc0e47630037870f6a23e.jpg";